import { atom } from "jotai";

export type LogoutModalState = {
  isOpen: boolean;
  resolve: (() => void) | null;
};

export const logoutModalAtom = atom<LogoutModalState>({
  isOpen: false,
  resolve: null,
});
